import useReduxForm from "./useReduxForm";
import { useSelector } from "react-redux";
import { getFormSyncErrors } from "redux-form";

export default function useFormSyncErrors() {
  const { form } = useReduxForm();
  return useSelector((state) => getFormSyncErrors(form)(state));
}
